import { render, staticRenderFns } from "./TipiFabbricato.vue?vue&type=template&id=0b7f34ee&"
import script from "./TipiFabbricato.vue?vue&type=script&lang=ts&"
export * from "./TipiFabbricato.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports